// Localização: frontend/src/pages/Assinatura/PendentePage.jsx
// Página para assinaturas pendentes de pagamento

import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Clock, AlertCircle, ArrowLeft, CheckCircle } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { getAssinatura } from '../../api/assinaturaApi';
import PrimaryButton from '../../components/Common/PrimaryButton';

const PendentePage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { fetchSubscription, subscription } = useAuth();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const atualizarAssinatura = async () => {
            try {
                // Buscar assinatura
                // NOTA: Sincronização com Mercado Pago removida - será reimplementada com Stripe
                const response = await getAssinatura();
                if (response.success && response.data) {
                    console.log('[PendentePage] Assinatura encontrada:', response.data);
                }
                await fetchSubscription();
            } catch (error) {
                console.error('[PendentePage] Erro ao buscar assinatura:', error);
            } finally {
                setLoading(false);
            }
        };

        atualizarAssinatura();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Executa apenas uma vez ao montar o componente

    const subscriptionId = searchParams.get('subscription_id');

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
                {loading ? (
                    <>
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-higeia-dark mx-auto mb-4"></div>
                        <p className="text-gray-600">Carregando...</p>
                    </>
                ) : (
                    <>
                        <div className="mb-6">
                            <Clock className="h-20 w-20 text-yellow-500 mx-auto" />
                        </div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-2">
                            Pagamento Pendente
                        </h1>
                        <p className="text-gray-600 mb-6">
                            Sua assinatura está aguardando confirmação de pagamento. Isso pode levar alguns minutos.
                        </p>

                        {subscription && (
                            <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left">
                                <div className="space-y-2">
                                    <div>
                                        <span className="text-sm text-gray-500">Plano:</span>
                                        <p className="font-semibold text-gray-900">{subscription.plano_nome}</p>
                                    </div>
                                    <div>
                                        <span className="text-sm text-gray-500">Status:</span>
                                        <p className="font-semibold text-yellow-600">{subscription.status}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
                            <div className="flex items-start">
                                <AlertCircle className="h-5 w-5 text-blue-600 mr-2 mt-0.5" />
                                <div>
                                    <h3 className="font-semibold text-blue-900 mb-1">
                                        O que fazer agora?
                                    </h3>
                                    <ul className="text-sm text-blue-700 space-y-1 list-disc list-inside">
                                        <li>Aguarde alguns minutos para o processamento</li>
                                        <li>Verifique seu email para confirmação</li>
                                        <li>Se o pagamento não for confirmado, você pode tentar novamente</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-3">
                            <PrimaryButton
                                onClick={() => navigate('/config/assinatura/gerenciar')}
                                className="w-full bg-higeia-dark hover:bg-higeia-medium"
                            >
                                Ver Status da Assinatura
                            </PrimaryButton>

                            <button
                                onClick={() => navigate('/pricing')}
                                className="w-full text-sm text-gray-500 hover:text-gray-700 transition-colors"
                            >
                                Voltar para Planos
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default PendentePage;


